/* eslint-disable no-undef */
// import './wdyr';
import React from "react";
import ReactDOM from "react-dom";
import "leaflet/dist/leaflet";
//Global Styles
import "leaflet/dist/leaflet.css";
import "react-contexify/dist/ReactContexify.css";
import "./_styles/_index.less";
import { Provider } from "react-redux";

import { store } from "./_helpers";
import {
  AppProvider,
  TimeProvider,
  ModalProvider,
  MapProvider,
} from "./_contexts";

//Need to find container, remove any children, get vars "data-world-id", "data-id" (for chronicleID) and then inject React App.
import { Chronos } from "./Chronos";

const rootElement = document.getElementById("chronicle-root");
const chronicleID = rootElement.getAttribute("data-id");
const worldID = rootElement.getAttribute("data-world-id");
let userWAID = null;
if (typeof userId !== "undefined") {
  userWAID = userId;
} else {
  const wid = localStorage.getItem("worldanvil-wid");
  // userWAID = window.global.userId || undefined;
  userWAID = wid && wid.length > 0 ? wid : null;
}
// console.log('[CHRONOS] Root Component Rendering');
ReactDOM.render(
  <>
    <Provider store={store}>
      <AppProvider>
        <ModalProvider>
          <TimeProvider>
            <MapProvider>
              <Chronos
                chronicleID={chronicleID}
                worldID={worldID}
                userID={userWAID}
              />
            </MapProvider>
          </TimeProvider>
        </ModalProvider>
      </AppProvider>
    </Provider>
  </>,
  rootElement
);
if (process.env.NODE_ENV === "development") {
  module.hot.accept();
}
